import { forwardRef, useState } from "react";
import {
  InputWrapper,
  StyledLabel,
  InputContainer,
  StyledInput,
  ErrorText,
  EyeButton,
} from "./Input.styles";
import { InputProps } from "../../../interfaces";

const EyeOpenIcon = () => (
  <svg
    width="1.1rem"
    height="1.1rem"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

const EyeClosedIcon = () => (
  <svg
    width="1.1rem"
    height="1.1rem"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
    <line x1="1" y1="1" x2="23" y2="23"></line>
  </svg>
);

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, type = "text", ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false);
    const isPasswordField = type === "password";

    const currentType = isPasswordField && showPassword ? "text" : type;

    return (
      <InputWrapper>
        {label && <StyledLabel>{label}</StyledLabel>}

        <InputContainer>
          <StyledInput
            ref={ref}
            type={currentType}
            $hasError={!!error}
            $hasIcon={isPasswordField}
            {...props}
          />

          {isPasswordField && (
            <EyeButton
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              tabIndex={-1} // Щоб Tab не фокусувався на глазіку при заповненні форми
              title={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <EyeClosedIcon /> : <EyeOpenIcon />}
            </EyeButton>
          )}
        </InputContainer>

        {error && <ErrorText>{error}</ErrorText>}
      </InputWrapper>
    );
  },
);

Input.displayName = "Input";
